/**
 * Portal Manta · OrcParamPage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, S } from '../../globals.js';
import { OrcamentoRevisaoTab } from './OrcamentoRevisaoTab.jsx';
import { SubSidebar } from '../sidebar/SubSidebar.jsx';
import { Breadcrumb } from '../sidebar/Breadcrumb.jsx';
import { ComparaTab } from '../lotes-tabs/ComparaTab.jsx';
import { ParamDfTab } from '../lotes-tabs/ParamDfTab.jsx';
import { MacroTab } from '../lotes-tabs/MacroTab.jsx';
import { EstruturaTab } from '../lotes-tabs/EstruturaTab.jsx';

const OrcParamPage = memo(function OrcParamPage_Inner({lote}){
  // Toda a lógica de Quadros 1 e 2 (KPIs gerais, distribuição CAPEX) foi extraída
  // para OrcamentoRevisaoTab — agora a sub-aba A é a tabela 3-colunas com ajustes manuais.

  // Sub-abas A · B · C · D (na SubSidebar lateral)
  const subs = [
    {k:'A', badge:'A', l:'Resumo do Orçamento',     sub:'KPIs gerais · distribuição'},
    {k:'B', badge:'B', l:'Compara Paramétrico',     sub:'PR Vias × Manta'},
    {k:'C', badge:'C', l:'Paramétrico Manta',       sub:'CAPEX hierárquico × SICRO'},
    {k:'D', badge:'D', l:'Macro + Estrutura',       sub:'Macro planejamento'},
  ];
  const [view, setView] = useState('A');
  const cur = subs.find(s=>s.k===view) || subs[0];

  return(<div style={{display:'flex',flex:1,overflow:'hidden'}}>
    {/* SubSidebar vertical (esquerda) */}
    <SubSidebar
      groups={[{id:'orcparam', label:'Paramétrico Manta', items:subs}]}
      activeKey={view}
      onSelect={setView}
      storageKey="manta-subbar-orcparam"
    />
    {/* Conteúdo (direita) */}
    <div style={{flex:1,display:'flex',flexDirection:'column',minWidth:0,overflow:'hidden'}}>
      {/* Breadcrumb compacto: substitui a barra horizontal + o indicador */}
      <div style={{padding:'7px 14px',background:'#fff',borderBottom:'1px solid '+V.b1,fontSize:10,color:V.gr,display:'flex',gap:8,alignItems:'center',flexShrink:0,flexWrap:'wrap'}}>
        <span style={{fontFamily:'ui-monospace,monospace',fontWeight:800,color:V.or}}>{cur.k}</span>
        <span style={{color:V.b1}}>›</span>
        <span style={{fontWeight:700,color:V.br}}>{cur.l}</span>
        <span style={{color:V.gr}}>· {cur.sub}</span>
        <span style={{...S.pillBase,background:V.or,color:'#fff',marginLeft:'auto'}}>OBRAS DE AMPLIAÇÃO</span>
      </div>

      {/* Conteúdo da sub-aba */}
      <div style={{flex:1,overflow:'auto',minWidth:0}}>

        {/* ───── A · RESUMO DO ORÇAMENTO PARAMÉTRICO MANTA ───── */}
        {/* ───── A · ORÇAMENTO PARAMÉTRICO MANTA — REVISÃO ───── */}
        {view==='A' && <OrcamentoRevisaoTab lote={lote}/>}

      {/* ───── B · COMPARA PARAMÉTRICO ───── */}
      {view==='B' && <ComparaTab lote={lote}/>}

      {/* ───── C · PARAMÉTRICO MANTA ───── */}
      {view==='C' && <ParamDfTab lote={lote}/>}

      {/* ───── D · MACRO + ESTRUTURA ───── */}
      {view==='D' && <>
        <MacroTab lote={lote}/>
        <EstruturaTab lote={lote}/>
      </>}
    </div>
    </div>
  </div>);
});

export { OrcParamPage };
export default OrcParamPage;
